export enum DefaultLanguage {
  FR = 1,
  EN = 2,
  ES = 3,
  DE = 4,
  PT = 5,
  IT = 6,
}

export const LanguageMap: Record<DefaultLanguage, string> = {
  [DefaultLanguage.FR]: "fr",
  [DefaultLanguage.EN]: "en",
  [DefaultLanguage.ES]: "es",
  [DefaultLanguage.DE]: "de",
  [DefaultLanguage.PT]: "pt",
  [DefaultLanguage.IT]: "it",
} as const
